export type TErrorType = {
  code: string;
  message: string;
};
export enum HttpStatusEnum {
  OK = 200,
  BadRequest = 400,
  NotFound = 404,
  ToManyRequest = 429,
  Unauthorized = 401,
  AccessDeneid = 403,
  InternalServerError = 500,
}
export interface IErrorResponse {
  status: HttpStatusEnum;
  type: string;
  detail: string;
  errors: TErrorType[];
  formatMessage: () => string;
}
export class ErrorResponse implements IErrorResponse {
  constructor(
    public status: HttpStatusEnum,
    public type: string,
    public detail: string,
    public errors: TErrorType[]
  ) {}

  formatMessage = (): string => {
    if (this.errors?.length > 0) {
      return this.errors.map((error) => error.message).join('\n');
    } else {
      return this.detail;
    }
  };
}
